// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j84GC","clinicsSelect":"styles_clinicsSelect__3vCQq"};